<template>
<div>
  <bLoading :loading="allLoading"></bLoading>
  <div v-if="!allLoading" class="page-account-info" ref="accountInfo">
    <bCardHeader :param="param" :buttons="buttons"></bCardHeader>
    <el-row :gutter="30" class="m-0">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-row class="m15">
          <div class="card-base card-shadow--small account-page-info">
            <div class="accountinfo-title" test_id="personal_info">{{$t('accountInfo.personalInfo')}}</div>
            <div class="card-list lh-22">
              <span class="info-name" test_id="name_info">{{$t('accountInfo.name')}}</span>
              <span class="info-value" v-if="clientInfo.type==='COMPANY'" test_id="name_info_value">{{clientInfo.name? (clientInfo.name):'--'}}</span>
              <span class="info-value" v-else test_id="name_info_value">{{(clientInfo.lastName && clientInfo.firstName)? (clientInfo.lastName+ ' ' +clientInfo.firstName):'--'}}</span>
            </div>
            <div class="card-list lh-22">
              <span class="info-name" test_id="phone_info">{{$t('accountInfo.phone')}}</span>
              <span class="info-value" test_id="phone_info_value">{{`+${clientInfo.phoneAreaCode}${clientInfo.mobile}`}}</span>
            </div>
            <div class="card-list lh-22">
              <span class="info-name" test_id="email_info">{{$t('accountInfo.email')}}</span>
              <span class="info-value" test_id="email_info_value">{{clientInfo.email}}</span>
            </div>
            <div class="card-list">
              <span class="info-name lh-22" test_id="address_info">{{$t('accountInfo.address')}}</span>
              <span class="info-value" test_id="address_info_value">{{clientInfo.address ? clientInfo.address : '--'}}</span>
            </div>
          </div>
        </el-row>
        <el-row>
          <div class="card-base card-shadow--small account-page-info m15" test_id="tradeaccount_info">
            <div class="accountinfo-title">{{$t('accountInfo.trading_account_info')}}</div>
            <div v-if="stockCashList.length">
              <account-item :accountList="stockCashList"
                    :selectItem="selectCashItem"
                    :num="stockCashNum"
                    typeKey="stockCashList"
                    @changeHandle="changeHandle"></account-item>
            </div>
            <div v-if="stockMarginList.length">
              <account-item :accountList="stockMarginList"
                    :selectItem="selectMarginItem"
                    :num="stockMarginNum"
                    typeKey="stockMarginList"
                    @changeHandle="changeHandle"></account-item>
            </div>
            <div v-if="futuresList.length">
              <account-item :accountList="futuresList"
                    :selectItem="selectfuturesItem"
                    :num="futuresNum"
                    typeKey="futuresList"
                    @changeHandle="changeHandle"></account-item>
            </div>
            <div v-if="otherAccountInfo.length">
              <el-card shadow="always"
                     class="trading-account mb-20"
                     v-for="value in otherAccountInfo"
                     :key="value.tradeAccountNumber">
              <div class="fx-col">
                <span class="name">
                  {{$t('tradeAccountType.'+ value.tradeAccountType)}}
                  <el-tooltip v-if="value.isDormant" popper-class="account-tip" effect="dark"  :content="$t('accountInfo.accountDormant', {accountNumber: value.tradeAccountNumber})" placement="top-start" >
                    <span class="what-dormant" >?</span>
                  </el-tooltip>
                  <span v-if="value.isDormant" class="account-status">{{$t('common.dormant ')}}</span>
                </span>
                <span class="status">{{$t('accountInfo.'+ value.status)}}</span>
              </div>
              <div class="dis-input">
                {{value.tradeAccountNumber}}
              </div>
              <div class="fx-col">
                <span class="left">
                  <div v-if="['MT5', 'MF', 'BULLION_MARGIN'].includes(value.tradeAccountType)" class="balance">{{$t('accountInfo.balance')}}</div>
                  <div v-else-if="value.tradeAccountType === 'FUTURES_MARGIN' || value.tradeAccountType === 'FUTURES_DAYTRADING_MARGIN'" class="balance">{{$t('accountInfo.todayBalance')}}</div>
                  <div v-else class="balance">{{value.tradeAccountType === 'INTERACTIVE_BROKER_INTEGRATED_MARGIN' ? '' : $t('accountInfo.netCashBalance')}}</div>
                </span>
                <span class="right">
                  <span class="v-balance" v-if="value.tradeAccountType !== 'INTERACTIVE_BROKER_INTEGRATED_MARGIN'">{{value.base_currency}}</span>&nbsp;
                  <span class="v-balance" v-if="value.tradeAccountType !== 'INTERACTIVE_BROKER_INTEGRATED_MARGIN'">{{isNaN(value.total_balance) ? value.total_balance : financial(value.total_balance)}}</span>
                </span>
              </div>
            </el-card>
            </div>

          </div>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="clientInfo.type!=='COMPANY'">
        <div class="card-base card-shadow--small account-page-info m15" test_id="bank_info">
          <div class="infos accountinfo-title">
            <div class="">{{$t('accountInfo.bankInfo')}}</div>
            <div class="record" @click="toApply">{{$t('accountInfo.toRecords')}} ></div>
          </div>
          <bEddidBankAccount :key="index" v-for="(value, index) in bankInfo" :accountInfo="value" class="bank-logo"></bEddidBankAccount>
          <div class="add-card" @click="toApply"><span>+</span><span>{{$t('accountInfo.addCard')}}</span></div>
        </div>
      </el-col>
    </el-row>
    <!-- <el-dialog :title="dialogtitle" :visible.sync="showDialog" width="30%" class="warn-dialog" :show-close="false">
        <div class="dialog-info">{{$t('accountInfo.withdrawalLimit')}}</div>
        <div class="dialog-footer">
          <el-button type="primary" @click="showDialog = false">{{$t('common.iknow')}}</el-button>
        </div>
      </el-dialog> -->
  </div>
</div>

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { getMyBank } from '@/api/v2/deposit'
// import { queryWithdrawalLimit } from '@/api/v2/fund'
import tradeRequest from '@/api/v2/trade'
import accountItem from './accountItem.vue'
export default {
  components: {
    accountItem
  },
  data() {
    return {
      account: {
        cbm: {
          icon: require('@/assets/images/banklogo/OTHER.png'),
          title: 'China Merchants Bank',
          acc_num: '6227 0028 7384 1344 291'
        }
      },
      allLoading: true,
      buttons: [],
      param: {
        title: 'account_info',
        links: [
          { title: 'home' },
          { title: 'my_account' },
          { title: 'account_info' }
        ]
      },
      bankInfo: [],
      personalInfo: this.$getProfile() || {},
      accountInfo: '',
      accountInfoHaveBalance: [],
      continueArr: ['IB', 'MF'],
      loadingFailTip: this.$t('common.loadingFailTip'),
      accountBalance: [],
      stockCashNum: '',
      stockMarginNum: '',
      futuresNum: '',
      stockCashList: [],
      stockMarginList: [],
      futuresList: [],
      otherAccountInfo: [],
      selectCashItem: {},
      selectMarginItem: {},
      selectfuturesItem: {},
      accountMap: {
        stockCashList: 'selectCashItem',
        stockMarginList: 'selectMarginItem',
        futuresList: 'selectfuturesItem'
      },
      dialogtitle: this.$t('logout.tips'),
      showDialog: false,
      isForbidWithdrawal: false
    }
  },
  created() {
    let arr = []
    // SP 隐藏期货账户
    if (this.userInfo.isSPAccount === 'Y') {
      arr = this.filterSPTradingAccountList || []
    } else {
      arr = this.getAllAccountInfo.filter(item => {
      return ['OPEN', 'STOP'].includes(item.status)
    })
    }
    arr = arr.map(item => {
      return {
        tradeAccountNumber: item.tradeAccountNumber,
        tradeAccountType: item.tradeAccountType,
        status: item.status,
        total_balance: this.$t('home.loadingData'),
        base_currency: '',
        type: item.type
      }
    })
    this.initData(arr)
    this.allLoading = false
    // this.queryWithdrawalLimit()
  },
  mounted() {
    this.getBankInfo()
    this.getAccountInfo()
  },
  computed: {
    ...mapGetters(['getClientProfile', 'getAllAccountInfo']),
    clientInfo() {
      return this.getClientProfile.userInfo
    },
    ...mapState(['filterSPTradingAccountList', 'userInfo'])
  },
  methods: {
    async getBankInfo() {
      try {
        let params = {
          type: 'OTHER',
          addressType: 'HongKong'
        }
        let result = await getMyBank(params)
        console.log(result, 'result')
        let info = []
        for (let value of result['data']) {
          let op = {
            icon: require(`@/assets/images/banklogo/${
              value['bankIcon'] === 'other' ? 'OTHER' : value['bankIcon']
            }.png`),
            title: value['bankName'],
            acc_num: value['bankNumber'],
            currency: value['currency'],
            bankType: value['bankType']
          }
          info.push(op)
        }
        let filterArr = ['JPY', 'SGD', 'MYR', 'IDR'] // 过滤东南亚二期币种
        info = info.filter(item => {
          return !filterArr.includes(item.currency)
        })
        this.bankInfo = info
        console.log(this.bankInfo, 'this.bankInfo')
      } catch (e) {
        console.log(e, 'ereeee')
        e.msg && this.$message.error(e.msg)
      }
    },
    // 获取已开通和停用的交易账户
    async getAccountInfo() {
      let res = await tradeRequest.getAccountInfo()
      if (res.code && res.code === 200) {
        if (this.userInfo.isSPAccount === 'Y') {
          let arr = res.data.filter((item) => {
            return item.type !== 'FUTURES'
          })
          this.initData(arr)
        } else {
          this.initData(res.data)
        }
      }
    },
    initData(list) {
      let obj = {}
        this.accountInfo = list.map(item => {
          // item.isDormant = true
          obj[item.tradeAccountType] = obj[item.tradeAccountType] || []
          obj[item.tradeAccountType].push({
            ...item,
            total_balance:
              typeof (item.moneyList &&
                item.moneyList[0] &&
                item.moneyList[0].totalBalance) === 'number' ? item.moneyList[0].totalBalance : '--',
            base_currency:
              (item.moneyList &&
                item.moneyList[0] &&
                item.moneyList[0].currency) ||
              '--'
          })
          return {
            ...item,
            total_balance:
              typeof (item.moneyList &&
                item.moneyList[0] &&
                item.moneyList[0].totalBalance) === 'number' ? item.moneyList[0].totalBalance : '--',
            base_currency:
              (item.moneyList &&
                item.moneyList[0] &&
                item.moneyList[0].currency) ||
              '--'
          }
        })
        this.otherAccountInfo = this.accountInfo.filter(item => {
          return ![
            'SECURITIES_MARGIN',
            'SECURITIES_CASH',
            'FUTURES_MARGIN',
            'VA'
          ].includes(item.tradeAccountType)
        })
        for (let key in obj) {
          obj[key].moneyList &&
            obj[key].moneyList.map(val => {
              obj[key].base_currency =
                val.currency || '--'
              obj[key].total_balance =
                val.totalBalance || '--'
            })
        }
        // 证券现金
        this.stockCashList =
          this.accountInfo.filter(item => {
            return item.tradeAccountType === 'SECURITIES_CASH'
          }) || []
        this.stockCashNum = this.stockCashList[0] && this.stockCashList[0].tradeAccountNumber
        this.selectCashItem = this.stockCashList[0]
        // 证券保证金
        this.stockMarginList =
          this.accountInfo.filter(item => {
            return item.tradeAccountType === 'SECURITIES_MARGIN'
          }) || []
        this.stockMarginNum = this.stockMarginList[0] && this.stockMarginList[0].tradeAccountNumber
        this.selectMarginItem = this.stockMarginList[0]
        // 期货
        this.futuresList =
          this.accountInfo.filter(item => {
            return item.tradeAccountType === 'FUTURES_MARGIN'
          }) || []
        this.futuresNum = this.futuresList[0] && this.futuresList[0].tradeAccountNumber
        this.selectfuturesItem = this.futuresList[0]
        console.log(this.otherAccountInfo, 'this.otherAccountInfo', 'this.stockMarginList: ', this.stockMarginList, 'this.stockCashList: ', this.stockCashList, 'this.futuresList: ', this.futuresList)
    },
    financial(x) {
      return this.Util.formatCurrency(x)
    },
    changeHandle(val, key) {
      this.accountMap[key] = this[key].find(item => {
        return item.tradeAccountNumber === val
      })
      if (key === 'stockCashList') {
        this.$set(this, `selectCashItem`, this.accountMap[key])
      } else if (key === 'stockMarginList') {
        this.$set(this, `selectMarginItem`, this.accountMap[key])
      } else {
        this.$set(this, `selectfuturesItem`, this.accountMap[key])
      }
    },
    // 查询是否禁止出金
    // async queryWithdrawalLimit() {
    //   let res = await queryWithdrawalLimit()
    //   if (res && res.code === 200) {
    //     let isWithdrawalLimit = res.data && res.data.isForbidWithdrawal
    //     this.isForbidWithdrawal = isWithdrawalLimit
    //     if (isWithdrawalLimit) {
    //       this.showDialog = true
    //     }
    //   }
    // },
    toApply () {
      this.$router.push({
        path: 'add-hkCard',
        query: { isForbidWithdrawal: this.isForbidWithdrawal }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/scss/_variables.scss';
.page-account-info {
  height: min-content;
  .warn-dialog {
    .dialog-info {
      font-size: 14px;
      font-weight: 400;
      color: #7d7d7d;
      line-height: 21px;
      &:first-of-type {
      margin-bottom: 15px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      padding-top: 30px;
      .el-button {
        padding: 18px 96px;
        background: #fec000;
        border-radius: 5px;
        color: #192b57;
        font-size: 14px;
      }
    }
  }
}
.account-page-info {
  padding: 20px 30px;
  margin-bottom: 20px;
  .infos {
    display: flex;
    justify-content: space-between;
    & .record {
      font-size: 12px;
      color: #fec703;
      cursor: pointer;
    }
  }
  .accountinfo-title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0 0 20px;
    padding-bottom: 20px;
    font-weight: 600;
    color: #182a54;
    font-size: 18px;
    font-family: Muli-Bold;
    letter-spacing: 0.22px;
  }
  .add-card {
    cursor: pointer;
    height: 80px;
    border-radius: 10px;
    box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
    line-height: 80px;
    padding-left: 20px;
    span:first-of-type {
      display: inline-block;
      font-size: 25px;
      color: #fec703;
      margin-right: 10px;
    }
    span:last-of-type {
      font-size: 15px;
      color: #666;
    }
  }
  .card-list {
    border-bottom: 1px solid #e2e2e2;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    box-sizing: border-box;
    .info-name {
      font-family: Muli-Regular;
      font-size: 12px;
      color: #666666;
      letter-spacing: 0.13px;
      min-width: 50px;
    }
    .info-value {
      font-family: Muli-Bold;
      font-size: 16px;
      color: #24282d;
      letter-spacing: 0.19px;
      text-align: right;
    }
    .info-value-cn {
      font-family: 'PingFangSC-Semibold';
    }
  }
  .el-card {
    background: #ffffff;
    box-shadow: 0 3px 7px 0 rgba(179, 179, 179, 0.5);
    border-radius: 10px;
  }
  .trading-account {
    border-left: 3px solid #fec000;
  }
}
.fx-col{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .name{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #24282D;
  }
  .status{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .v-balance{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .left{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
}
.dis-input{
  height: 40px;
  background: #F3F4F6;
  border-radius: 5px;
  border: 1px solid #E2E2E2;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #24282D;
  line-height: 40px;
  padding-left: 20px;
  margin-bottom: 12px;

}

.text {
  font-weight: bold;
  font-size: 17px;
}

.bankInfo {
  margin-bottom: 20px;
  .bank-logo {
    display: inline-block;
    width: 55px !important;
    height: 55px !important;
    border-radius: 50% !important;
    margin-right: 20px;
  }
  .bank-list {
    display: flex;
    flex-direction: column;
    .line1 {
      margin-bottom: 10px;
    }
  }
}
.mb-30 {
  margin-bottom: 30px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.lh-22 {
  line-height: 22px;
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .m15 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
.warn-dialog {
  .dialog-info {
    font-size: 14px;
    font-weight: 400;
    color: #7d7d7d;
    line-height: 21px;
    &:first-of-type {
      margin-bottom: 15px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 30px;
    .el-button {
      padding: 18px 96px;
      background: #fec000;
      border-radius: 5px;
      color: #192b57;
      font-size: 14px;
    }
  }
}
.account-status{
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #24282D;
  background: #F3F4F6;
  padding: 5px 10px;
  border-radius: 5px;
}
.what-dormant{
 margin-left: 10px;
 cursor: pointer;
}
</style>
<style lang="scss" >
.account-tip{
  width: 400px;
}
</style>
